import { Spin } from "antd";
import { useEffect, useState } from "react";

import RouteList from "@/routes/RouteList";
import { useTenantStore } from "@/stores/tenantStore";

const App: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initialize = async () => {
      try {
        await useTenantStore.getState().getBackendApiUrl();
      } finally {
        setLoading(false);
      }
    };

    void initialize();
  }, []);

  if (loading) {
    return <Spin fullscreen />;
  }

  return <RouteList />;
};

export default App;
